import { render } from "./ui-task-edit.vue?vue&type=template&id=93834086&scoped=true"
import script from "./ui-task-edit.vue?vue&type=script&lang=js"
export * from "./ui-task-edit.vue?vue&type=script&lang=js"

import "./ui-task-edit.vue?vue&type=style&index=0&id=93834086&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93834086"]])

export default __exports__